import { get } from 'lodash';

const root = state => get(state, 'CommonState.connection');

export const getOnline = state => get(root(state), 'online', false);
export const getServerUp = state => get(root(state), 'serverUp', false);
export const getOfflineMode = state => get(root(state), 'offlineMode', false);
export const getOfflineSyncInProgress = state =>
  get(root(state), 'offlineSyncInProgress', false);



// WEBPACK FOOTER //
// ./src/state/connection/selectors.js